import {
  Answer,
  FaqStructuredData,
  Faqs,
  Question,
  Faq as VCCFaq,
} from '@vcc-package/accordions';
import { TrackingProvider } from '@volvo-cars/tracking';

import Markdown from 'molecules/Markdown';

type QA = {
  question: string;
  answer: string;
};

export type FaqItem = QA & {
  defaultExpanded?: boolean;
};

const Faq: React.FC<{
  items: FaqItem[];
  structuredData?: QA[];
}> = ({ items, structuredData }) => (
  <TrackingProvider eventCategory="faq">
    <div className="bg-secondary p-16 md:p-48">
      <Faqs>
        {items.map(({ question, answer, defaultExpanded }, index) => (
          <VCCFaq
            key={index}
            defaultOpen={defaultExpanded}
            className={index === 0 ? 'border-t border-ornament' : ''}
            trackEventLabel={
              question.length > 200
                ? `${question.substring(0, 200)}...`
                : question
            }
          >
            <Question className="font-16 font-medium py-24">
              {question}
            </Question>
            <Answer className="pb-24">
              <Markdown>{answer}</Markdown>
            </Answer>
          </VCCFaq>
        ))}
      </Faqs>
    </div>
    {structuredData && <FaqStructuredData faqs={structuredData} />}
  </TrackingProvider>
);

export default Faq;
